// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#venusUI {
  /**
   * Usage:
   *    p { .withBorder() } => p { border: @box-border }
   *    p { .withBorder(@border: @border) } => p { border: @border }
   *    p { .withBorder(true; @border) } => p { border: @border }
   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }
   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }
   */
}
.n-color-swatch {
  border: 0;
  margin: 0;
  padding: 0;
}
.n-color-swatch--active {
  border: 2px solid var(--color-popover-background);
  outline: 1px solid var(--color-accent-background-down);
}
.n-color-swatch--empty {
  background: var(--color-popover-background);
  border: 1px solid var(--color-border-base);
}
.n-color-swatch:hover {
  border: 1px solid var(--color-popover-background);
}
.n-color-swatch--color-elm {
  background-color: #1e6d71;
}
.n-color-swatch--color-green-vogue {
  background-color: #021f4e;
}
.n-color-swatch--color-orient {
  background-color: #005879;
}
.n-color-swatch--color-endeavour {
  background-color: #055fb3;
}
.n-color-swatch--color-eastern-blue {
  background-color: #138aae;
}
.n-color-swatch--color-bali-hai {
  background-color: #88a3aa;
}
.n-color-swatch--color-pelorous {
  background-color: #34b5ba;
}
.n-color-swatch--color-shamrock {
  background-color: #33cc99;
}
.n-color-swatch--color-old-gold {
  background-color: #d1ba33;
}
.n-color-swatch--color-malachite {
  background-color: #1dd65f;
}
.n-color-swatch--color-mantis {
  background-color: #87bf56;
}
.n-color-swatch--color-di-serria {
  background-color: #dd9e5f;
}
.n-color-swatch--color-tree-poppy {
  background-color: #f7931e;
}
.n-color-swatch--color-flamingo {
  background-color: #f15a24;
}
.n-color-swatch--color-roman {
  background-color: #d74d52;
}
.n-color-swatch--color-stiletto {
  background-color: #8f2c2f;
}
.n-color-swatch--color-violet-eggplant {
  background-color: #a0187d;
}
.n-color-swatch--color-dallas {
  background-color: #754c24;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/venus/ui/less/mixins/decorators.less","webpack://./src/neptune-app/libs/shared/venus/ui/components/color-picker/ColorSwatch.less"],"names":[],"mappings":"AAEA;ECDE;;;;;;;IAOE;AACJ;AAPA;EACE,SAAA;EACA,SAAA;EACA,UAAA;AASF;AAPE;EACE,iDAAA;EACA,sDAAA;AASJ;AANE;EACE,2CAAA;EACA,0CAAA;AAQJ;AALE;EACE,iDAAA;AAOJ;AAHK;EACC,yBAAA;AAKN;AANK;EACC,yBAAA;AAQN;AATK;EACC,yBAAA;AAWN;AAZK;EACC,yBAAA;AAcN;AAfK;EACC,yBAAA;AAiBN;AAlBK;EACC,yBAAA;AAoBN;AArBK;EACC,yBAAA;AAuBN;AAxBK;EACC,yBAAA;AA0BN;AA3BK;EACC,yBAAA;AA6BN;AA9BK;EACC,yBAAA;AAgCN;AAjCK;EACC,yBAAA;AAmCN;AApCK;EACC,yBAAA;AAsCN;AAvCK;EACC,yBAAA;AAyCN;AA1CK;EACC,yBAAA;AA4CN;AA7CK;EACC,yBAAA;AA+CN;AAhDK;EACC,yBAAA;AAkDN;AAnDK;EACC,yBAAA;AAqDN;AAtDK;EACC,yBAAA;AAwDN","sourcesContent":["@import \"../variables.less\";\n\n#venusUI {\n\n  /**\n   * Usage:\n   *    p { .withBorder() } => p { border: @box-border }\n   *    p { .withBorder(@border: @border) } => p { border: @border }\n   *    p { .withBorder(true; @border) } => p { border: @border }\n   *    p { .withBorder(left top) } => p { border-left: @box-border; border-top: @box-border; }\n   *    p { .withBorder(left top; @border) } => p { border-left: @border; border-top: @border; }\n   */\n  .withBorder(@sides: true; @border: @box-border ) {\n    .setBorder(@side) when (@side) {\n      border: @border;\n    }\n    .setBorder(@side) when (@side = left), (@side = right), (@side = top), (@side = bottom){\n      border-@{side}: @border;\n    }\n    each(@sides, {\n      .setBorder(@value);\n    });\n  }\n\n  .withBorderRadius(@radius: @box-border-radius) {\n    border-radius: @radius;\n  }\n\n  .withShadow(@shadow: @box-shadow) {\n    box-shadow: @shadow;\n  }\n}\n","@import \"~venus\";\n\n.n-color-swatch {\n  border: 0;\n  margin: 0;\n  padding: 0;\n\n  &--active {\n    border: 2px solid var(--color-popover-background);\n    outline: 1px solid var(--color-accent-background-down);\n  }\n\n  &--empty {\n    background: var(--color-popover-background);\n    border: 1px solid var(--color-border-base);\n  }\n\n  &:hover {\n    border: 1px solid var(--color-popover-background);\n  }\n\n  .forEachNamedColor({\n    &--color-@{colorName} {\n      background-color: @colorValue;\n    }\n  });\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
